/* unplugin-vue-components disabled */import script from "./DcModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DcModal.vue?vue&type=script&setup=true&lang=js"

import "./DcModal.vue?vue&type=style&index=0&id=6543361b&lang=scss"

const __exports__ = script;

export default __exports__